// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1du6f","importantInfo":"styles_importantInfo__38yXX"};